import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "pa-3 pb-0" }
const _hoisted_2 = { class: "text-caption text-grey-darken-1" }
const _hoisted_3 = { class: "tp-panel__body pa-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-grey mb-3"
}
const _hoisted_6 = { class: "d-flex align-center flex-wrap ga-1" }
const _hoisted_7 = { class: "text-caption font-weight-bold tp-thread__author" }
const _hoisted_8 = { class: "text-caption text-grey-darken-1 tp-thread__at" }
const _hoisted_9 = { class: "text-body-2 mt-1 tp-thread__body" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "text-caption font-weight-bold" }
const _hoisted_12 = { class: "text-caption text-grey-darken-1 ml-2" }
const _hoisted_13 = { class: "text-body-2 tp-thread__body" }
const _hoisted_14 = { class: "mt-2 d-flex align-center ga-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_16 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_17 = { class: "d-flex justify-end mt-1" }
const _hoisted_18 = { class: "d-flex justify-end mt-2" }
const _hoisted_19 = { class: "text-caption text-grey-darken-1 mb-1" }
const _hoisted_20 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_21 = { class: "text-caption text-grey-darken-1 mb-2" }
const _hoisted_22 = {
  key: 0,
  class: "text-caption text-grey mt-3"
}
const _hoisted_23 = {
  key: 1,
  class: "text-caption text-grey mt-3"
}
const _hoisted_24 = { class: "text-body-2 tp-thread__body" }
const _hoisted_25 = { class: "d-flex justify-end" }
const _hoisted_26 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_27 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_28 = {
  key: 1,
  class: "text-caption text-grey"
}
const _hoisted_29 = { class: "text-caption text-grey-darken-1" }
const _hoisted_30 = { class: "text-body-2 tp-thread__body mt-1" }
const _hoisted_31 = { class: "d-flex justify-end ga-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    class: "tp-panel"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-subtitle-2" }, "入力支援", -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectedCell ? _ctx.selectedCell.name : "セルを選択してください"), 1)
      ]),
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        color: "primary",
        density: "compact",
        grow: "",
        class: "mt-2 tp-panel__tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "comment" }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createTextVNode(" コメント ", -1)),
              (_ctx.unresolvedTotal > 0)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    class: "ml-1",
                    size: "x-small",
                    variant: "flat",
                    color: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.unresolvedTotal), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "phrase" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("文例", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "past" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("過去参照", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tab === 'comment')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.selectedItemKey)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " コメントを見るセルを選択してください。 "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.threads.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " このセルにはまだコメントがありません。 "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.threads, (thread) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: thread.commentId,
                        class: "tp-thread mb-3"
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(thread.authorName), 1),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDateTime(thread.createdAt)), 1),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_chip, {
                            color: thread.isResolved ? 'success' : 'warning',
                            size: "x-small",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(thread.isResolved ? "解決済み" : "未解決"), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(thread.body), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thread.replies, (reply) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: reply.commentId,
                            class: "tp-reply mt-2"
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(reply.authorName), 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDateTime(reply.createdAt)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(reply.body), 1)
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_btn, {
                            size: "x-small",
                            variant: "text",
                            color: "primary",
                            onClick: ($event: any) => (_ctx.replyTo = _ctx.replyTo === thread.commentId ? null : thread.commentId)
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode(" 返信 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            size: "x-small",
                            variant: "text",
                            color: thread.isResolved ? 'grey-darken-1' : 'success',
                            loading: _ctx.resolvingCommentId === thread.commentId,
                            onClick: ($event: any) => (_ctx.toggleResolve(thread))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(thread.isResolved ? "未解決に戻す" : "解決にする"), 1)
                            ]),
                            _: 2
                          }, 1032, ["color", "loading", "onClick"]),
                          (thread.isResolved && thread.resolvedByName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(thread.resolvedByName) + "が解決 ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.replyTo === thread.commentId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.replyBody,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.replyBody) = $event)),
                                rows: "2",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "",
                                color: "primary",
                                placeholder: "返信を入力",
                                counter: _ctx.commentBodyMaxLength
                              }, null, 8, ["modelValue", "counter"]),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  variant: "text",
                                  onClick: _ctx.cancelReply
                                }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("キャンセル", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  color: "primary",
                                  variant: "flat",
                                  disabled: !_ctx.isValidBody(_ctx.replyBody),
                                  loading: _ctx.posting,
                                  onClick: ($event: any) => (_ctx.postComment(thread.commentId))
                                }, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode(" 送信 ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["disabled", "loading", "onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createVNode(_component_v_divider, { class: "my-3" }),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.newBody,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newBody) = $event)),
                      rows: "3",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary",
                      placeholder: "このセルへのコメントを入力",
                      counter: _ctx.commentBodyMaxLength
                    }, null, 8, ["modelValue", "counter"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        color: "primary",
                        variant: "flat",
                        disabled: !_ctx.isValidBody(_ctx.newBody),
                        loading: _ctx.posting,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.postComment(null)))
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" コメントする ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ])
                  ], 64)),
              (_ctx.otherUnresolvedItems.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_v_divider, { class: "my-3" }),
                    _createElementVNode("div", _hoisted_19, " 他に未解決" + _toDisplayString(_ctx.otherUnresolvedItems.length) + "項目 ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherUnresolvedItems, (item) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: item.itemKey,
                        class: "mr-1 mb-1",
                        size: "small",
                        variant: "outlined",
                        color: "warning",
                        onClick: ($event: any) => (_ctx.$emit('jump-item', item.itemKey))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name) + "（" + _toDisplayString(item.count) + "） ", 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.tab === 'phrase')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.selectedCell || !_ctx.selectedCell.phraseKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " このセルには文例グループが設定されていません。帳票設定で設定できます。 "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_21, " 文例グループ: " + _toDisplayString(_ctx.selectedCell.phraseKey), 1),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.phraseKeyword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phraseKeyword) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        clearable: "",
                        color: "primary",
                        placeholder: "文例を検索",
                        "prepend-inner-icon": "mdi-magnify",
                        onKeyup: _withKeys(_ctx.loadPhrases, ["enter"]),
                        "onClick:clear": _ctx.clearPhraseKeyword
                      }, null, 8, ["modelValue", "onKeyup", "onClick:clear"]),
                      (_ctx.loadingPhrases)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "読み込み中..."))
                        : (_ctx.phrases.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 登録された文例がありません。 "))
                          : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phrases, (phrase) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: phrase.phraseId,
                          class: "tp-suggest mt-2"
                        }, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(phrase.body), 1),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              variant: "text",
                              color: "primary",
                              disabled: !_ctx.editable,
                              onClick: ($event: any) => (_ctx.$emit('insert-text', phrase.body))
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode(" 本文に挿入 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ], 64))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!_ctx.selectedItemKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, " セルを選択してください。 "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.loadingPastValues)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "読み込み中..."))
                        : (_ctx.pastValues.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 過去の帳票に同じ項目の記入がありません。 "))
                          : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pastValues, (past, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${past.planId}-${index}`,
                          class: "tp-suggest mt-2"
                        }, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(past.planLabel), 1),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(past.value), 1),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              variant: "text",
                              onClick: ($event: any) => (_ctx.$emit('jump-plan', past.planId))
                            }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode(" 帳票を開く ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              variant: "text",
                              color: "primary",
                              disabled: !_ctx.editable,
                              onClick: ($event: any) => (_ctx.$emit('insert-text', past.value))
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" 本文に挿入 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ], 64))
              ], 64))
      ])
    ]),
    _: 1
  }))
}